export const STEPS = {
  REVIEW: "REVIEW",
  FIX: "FIX"
};

// titles per step
export const STEP_TITLES = {
  [STEPS.REVIEW]: "confirmPopup.updateWizardIncompatibleItemsTitle",
  [STEPS.FIX]: "confirmPopup.sqftIncompatibleTitle",
};
